import Medium from 'medium.js';
import Mousetrap from 'mousetrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateAddReplyError, updateInGuestFlowReply } from 'actions/comments';
import { COMMAND, CTRL, ENTER } from 'constants/keyCodes';
import { COMMAND_ENTER, CTRL_ENTER } from 'constants/mousetrap';
import { addReplyCreator } from 'creators/comments';
import { addMention } from 'utilities/comments';
import { stripContent } from 'utilities/mediumHelpers';

import { MAX_COMMENT_LENGTH } from 'validate';

import GuestFlow from '../../guest-flow';
import CommentMentions from '../../../mentions';

import Button from 'components/ui-components/button';

import './styles.less';

const AddReply = class extends Component {
  state = {
    did_mount: false,
    add_reply_enabled: false,
    comment_mentions: {},
  };

  render() {
    const {
      errorAddReply,
      isFetching,
      isInGuestFlowReply,
      brandColor,
    } = this.props;
    const { did_mount: didMount, add_reply_enabled } = this.state;

    const errorAddReplyClass = errorAddReply ? 'error' : '';
    const postReplyActive = add_reply_enabled ? 'is-active' : '';

    return (
      <div
        className={`add-reply-view ${
          isInGuestFlowReply ? 'hidden-content' : ''
        }`}
      >
        {isInGuestFlowReply && (
          <GuestFlow
            buttonStyle={brandColor ? { backgroundColor: brandColor } : null}
            addComment={this.addReply}
            resetNoGuestFlow={this.resetGuestFlow}
          />
        )}
        <div className={`add-reply-box ${errorAddReplyClass}`}>
          <div
            className="add-reply-content"
            tabIndex="-1"
            ref={addReplyContent => (this.addReplyContent = addReplyContent)}
            onKeyUp={this.onKeyUp}
            onInput={this.validateReply}
          />
          <div
            className={`add-reply-actions ${
              isInGuestFlowReply ? 'hidden' : ''
            }`}
          >
            <div
              className="click-through-area"
              onClick={() => this.addReplyContent.focus()}
            />
            <div className="add-reply-actions-save">
              {errorAddReply && (
                <span className="validation-error-react">{errorAddReply}</span>
              )}
              <Button
                buttonClass={postReplyActive}
                style={brandColor ? { backgroundColor: brandColor } : null}
                buttonType="rp-primary-4"
                disabled={isFetching || !add_reply_enabled}
                value="Post"
                onClicked={this.addReply}
              />
            </div>
          </div>
        </div>
        {didMount && (
          <CommentMentions
            onMentionClick={this.addMention}
            listeneeClass=".add-reply-content"
          />
        )}
      </div>
    );
  }

  addMention = ({ result, query }, trigger) => {
    this.setState({
      comment_mentions: addMention(
        result,
        query,
        '.add-reply-content',
        this.state.comment_mentions,
        trigger
      ),
    });
  };

  addReply = () => {
    const { comment, isInGuestFlowReply, isLoggedIn } = this.props;

    const strippedMediumContent = this.stripMediumContent();

    if (strippedMediumContent.length === 0) {
      this.props.updateAddReplyError('Cannot be empty');

      return;
    }

    if (!isLoggedIn && !isInGuestFlowReply) {
      return this.props.updateInGuestFlowReply(true);
    }

    this.props.addReply(
      strippedMediumContent,
      comment.id,
      this.state.comment_mentions
    );

    this.props.updateInGuestFlowReply(false);
    this.setState({ comment_mentions: {} });
  };

  stripMediumContent = () => {
    if (this.medium == null) {
      return;
    }

    return stripContent(this.medium);
  };

  resetGuestFlow = () => {
    this.props.updateInGuestFlowReply(false);
  };

  componentDidMount() {
    this.medium = new Medium({
      attributes: null,
      autofocus: false,
      autoHR: false,
      element: this.addReplyContent,
      mode: Medium.richMode,
      maxLength: MAX_COMMENT_LENGTH,
      pasteAsText: false,
      placeholder: 'Reply to comment',
      tags: null,
    });

    this.addMousetrapBindings();
    this.setState({ did_mount: true });
  }

  addMousetrapBindings = () => {
    Mousetrap(this.addReplyContent).bind([CTRL_ENTER, COMMAND_ENTER], () => {
      this.addReply();
    });
  };

  onKeyUp = e => {
    if (e.keyCode === COMMAND || e.keyCode === CTRL || e.keyCode === ENTER) {
      return;
    }
  };

  validateReply = () => {
    this.setState({
      add_reply_enabled:
        this.addReplyContent && this.addReplyContent.innerText !== '',
    });

    this.props.updateAddReplyError(null);

    // Fix for Medium not updating when content is inserted via emoji picker on macos
    this.medium.html.placeholders();
  };
};

const mapStateToProps = state => {
  const {
    error_add_reply: errorAddReply,
    is_fetching: isFetching,
    in_guest_flow_reply: isInGuestFlowReply,
  } = state.comments;

  const { is_logged_in: isLoggedIn } = state.user;

  return { errorAddReply, isFetching, isInGuestFlowReply, isLoggedIn };
};

const mapDispatchToProps = dispatch => {
  return {
    addReply: (content, commentId, mentions) =>
      dispatch(addReplyCreator(content, commentId, mentions)),
    updateAddReplyError: err => dispatch(updateAddReplyError(err)),
    updateInGuestFlowReply: inGuestFlowReply =>
      dispatch(updateInGuestFlowReply(inGuestFlowReply)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddReply);
